/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../../lib/@waca/dashboard-common/dist/core/APIFactory', './UserProfileAPI'], (APIFactory, UserProfileAPI) => {

	/**
	 * @class
	 * @implements UserProfileAPI
	 * @hideconstructor
	 * @classdesc default implementation of the UserProfileAPI
	 */
	class UserProfileImpl {

		constructor() {
			this._api = APIFactory.createAPI(this,[UserProfileAPI]);
			this._capabilities = {
				'canAuthorDashboard': true,
				'canUseInteractiveDashboard': true
			};
		}

		/**
		 * it is required in order to be defined as a dashboard feature
		 * @returns {Object} instance of the API implementation
		 */
		getAPI() {
			return this._api;
		}

		getAvailableContentLocales(){
			return Promise.resolve(null);
		}

		getValidDomainList(){
			return null;
		}

		/**
		 *
		 * @param {string} capabilityName
		 * @returns {boolean} true for the built-in capabilities, false otherwise
		 */
		hasCapability(capabilityName) {
			const hasIt = capabilityName ? !!this._capabilities[capabilityName] : false;
			return hasIt;
		}

		getContentLocale(){ return 'en';}

		getProductLocale(){ return 'en';}

		getUserAccount() {
			return {
				defaultName: undefined,
				userName: undefined,
				id: undefined
			};
		}
	}

	return UserProfileImpl;
});
